import { Card, Container } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import ReportComponent from "../core/ReportComponent"
import { parsedUser } from "../common/GetCurrentUser"

const PlacesByAgentsPage = () => {
    const { t } = useTranslation("global")
    const user = parsedUser()

    if (!user?.OrganizationId) {
        return (
            <Container fluid>
                <Card className="my-4">
                    <Card.Body>{t("Organization not selected")}</Card.Body>
                </Card>
            </Container>
        )
    }

    return (
        <ReportComponent
            title={t("Places By Agents")}
            fileName="visit-report-per-agent"
            endpoint={`reports/PlacesByAgents?OrganizationId=${user.OrganizationId}`}
            // groupBy="city"
            columns={[
                {
                    key: "agent",
                    label: t("Agent"),
                    sortable: true,
                },
                {
                    key: "places",
                    label: t("Places"),
                    sortable: true,
                    className: "text-end",
                },

            ]}
            filterFields={[]}
        />
    )
}

export default PlacesByAgentsPage
